import { useMemo } from 'react';
import styles from './styles.module.scss';
import { earningsData } from '@/constants/earnings';
import AffiliateCard from './Card';
import getEarningsCards from '@/utils/affiliates/getEarningDataCard';

export default function EarningsCards() {
  //switch with hook useAffiliatesVariant
  const EarningCards = getEarningsCards(earningsData);

  const Cards: JSX.Element[] = useMemo(
    () =>
      EarningCards.map((earning, i) => (
        <AffiliateCard
          key={`earning_card_${i}`}
          title={earning.title}
          image={earning.image}
          description={earning.description}
        />
      )),
    [EarningCards],
  );

  return <div className={styles.container}>{Cards}</div>;
}
